export default __webpack_public_path__ + "d3fbaf2b81fd92c49692626bdf436db8.gif";